<div class="modal-header">
  <h2>{{ getTitle() }}</h2>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
    >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body p-3">
  <div>{{ getMessage() }}:</div>
  <ul class="items-names-list">
    @for (name of config.items; track name) {
      <li>{{ name }}</li>
    }
  </ul>
</div>

<div class="modal-footer">
  <button
    class="button-danger"
    (click)="confirm()"
    >
    {{ 'GLOBAL.CONFIRM' | translate }}
  </button>
  <button
    class="button-outline-primary"
    (click)="activeModal.dismiss()"
    >
    {{ 'GLOBAL.UNDO' | translate }}
  </button>
</div>
